export class changePasswordModel{

        "userId":Number;
    "oldPassword":Number;
        "newPassword":Number;
        
}